import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Contact Info */}
        <div className="footer-section contact">
          <h3>Contact Us</h3>
          <p>Nimgaon Ketki Gram Panchayat</p>
          <p>Village Nimgaon Ketki, Taluka - Indapur, Dist. Pune, Maharashtra</p>
          <p>Phone: +91 12345 67890</p>
          <p>Email: gpnkgrampanchayat1935@gmail.com</p>
        </div>

        {/* Quick Links */}
        <div className="footer-section links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">About Us</a></li>
            <li><a href="#">Notices</a></li>
            <li><a href="#">Services</a></li>
            <li><a href="#">Documents</a></li>
          </ul>
        </div>

        {/* Logos / Related Links */}
        <div className="footer-section logos">
          <h3>Related Links</h3>
          <div className="footer-logos">
            <a href="https://india.gov.in" target="_blank" rel="noreferrer">
              <img src="/images/embelm.png" alt="Government of India" />
            </a>
            <a href="https://swachhbharat.mygov.in/" target="_blank" rel="noreferrer">
              <img src="/images/swachh_logo.png" alt="Swachh Bharat" />
            </a>
          </div>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>© 2025 Nimgaon Ketki Gram Panchayat. All rights reserved.</p>
        <p>Designed & Maintained by ElevateDev</p>
      </div>
    </footer>
  );
};

export default Footer;
